export function wrapElements(rawElements, readOnly = false) {
  return (rawElements || []).map(element => ({
    type: element.type,
    text: {value: element.text, type: 'text', readOnly},
    durationQuantity: {value: element.durationQuantity, type: 'number', step: 0.25, readOnly},
    unitPrice: {value: element.unitPrice, type: 'number', step: 0.25, readOnly},
    discountedRate: {value: element.discountedRate, type: 'number', readOnly},
    tva: {value: element.tva, type: 'number', readOnly},
    amount: {value: element.amount, type: 'number', readOnly: true},
  }));
}